module.exports = __webpack_public_path__ + "static/media/plan_upgrade.c8f6b111.svg";